import { render } from "./IconVegetarien.vue?vue&type=template&id=fc4f9c68"
import script from "./IconVegetarien.vue?vue&type=script&lang=js"
export * from "./IconVegetarien.vue?vue&type=script&lang=js"

import exportComponent from "D:\\perso\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__